import { render, staticRenderFns } from "./otaInfo.vue?vue&type=template&id=cb4ce10c&scoped=true&"
import script from "./otaInfo.vue?vue&type=script&lang=js&"
export * from "./otaInfo.vue?vue&type=script&lang=js&"
import style0 from "./otaInfo.vue?vue&type=style&index=0&id=cb4ce10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4ce10c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
